/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, february 2021
 * @format
 * @flow
 */

import React from "react";
import styles from "./NetworkLogs.module.css";
import constants from "../../../../globalization";
import PopupHeader from "../PopupHeader";

const NetworkLogs = (props) => {
  const {
    onClose,
    networkLogs = [],
  } = props || {};

  const renderHeader = () => (
    <div className={styles.headerRow}>
      <div className={styles.headerTxt}>{constants.urlSmall}</div>
      <div className={styles.headerTxt}>{constants.request}</div>
      <div className={styles.headerTxt}>{constants.response}</div>
    </div>
  );

  const renderLog = (log, index) => (
    <div className={styles.row} key={`url-${index}`}>
      <div className={styles.textWrapper}>{log.url}</div>
      <div className={styles.textWrapper}>{log.payload}</div>
      <div
        className={styles.textWrapper}
        style={{ color: log.status === 'FAILURE' ? 'red' : 'black' }}
      >
        {log.response}
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      <PopupHeader title={constants.networkLogs} onClose={onClose} />
      {renderHeader()}
      <div className={styles.logsWrapper}>
        {networkLogs && networkLogs.map((log, index) => renderLog(log, index))}
      </div>
    </div>
  );
};

export default NetworkLogs;
